import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID } from './audienceInsightsDemographicsReportId';

// columns that can be selectively toggled 'On' and 'Off' in the custom columns view
const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.IMPRESSIONS_PCT.field,
        FIELDS.VCTR.field,
        FIELDS.CLICKS_PCT.field,
        FIELDS.AVERAGE_CPC.field,
        FIELDS.VCPM.field,
        FIELDS.SPENT.field,
        FIELDS.CVR.field,
        FIELDS.CONVERSIONS_PCT.field,
        FIELDS.CPA.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.CVR_VS_AVG.field,
        FIELDS.ROAS.field,
    ].map(field => generateColumnId(AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID, field)),
    [REPORT_PRESET.SETUP]: [FIELDS.ID.field].map(field =>
        generateColumnId(AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID, field)
    ),
};

const defaultColumns = [
    FIELDS.IS_SELECTED.field,
    FIELDS.AUDIENCE_NAME.field,
    FIELDS.SPENT.field,
    FIELDS.IMPRESSIONS_PCT.field,
    FIELDS.VCTR.field,
    FIELDS.CLICKS_PCT.field,
    FIELDS.AVERAGE_CPC.field,
    FIELDS.VCPM.field,
    FIELDS.CVR.field,
    FIELDS.CONVERSIONS_PCT.field,
    FIELDS.CPA.field,
    FIELDS.CVR_VS_AVG.field,
].map(field => generateColumnId(AUDIENCE_INSIGHTS_DEMOGRAPHICS_REPORT_ID, field));

export { customColumns, defaultColumns };
